'use client';

import { useRouter } from 'next/router';
export default function useCustomLocale() {
  var router = useRouter();
  var localeLanguage = (router === null || router === void 0 ? void 0 : router.locale) === 'gb' ? 'en' : 'de';
  var language = router !== null && router !== void 0 && router.locale ? localeLanguage : 'en';
  var country = language === 'en' ? 'gb' : 'de';
  return {
    country,
    language
  };
}